import {HashRouter, Route, Routes} from "react-router-dom";
import RequireAuth from "./security/RequireAuth";
import App from "./App";
import Home from "./pages/Home";
import Login from "./pages/Login";
import InternalError from "./pages/errors/InternalError";
import NotFound from "./pages/errors/NotFound";
import React from "react";
import AccessDenied from "./pages/errors/AccessDenied";
import NetworkError from "./pages/errors/NetworkError";
import ContractMaintenanceFormPage from "./pages/contract/variable/ContractMaintenanceFormPage";
import Logout from "./pages/Logout";
import CreditVariablesMaintenanceFormPage from "./pages/credit/variables/CreditVariablesMaintenanceFormPage";
import ProvidersForm from "./pages/credit/providers/ProvidersForm";

const AppRoutes = () => {

    const ADMIN = 'ADMIN';
    const OPERATOR = 'PARTNER_OPERATOR';

    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<RequireAuth roles={[ADMIN, OPERATOR]}><App /></RequireAuth>} errorElement={<InternalError />}>
                    <Route path="home" element={<Home />} />
                    <Route path="denied" element={<AccessDenied />} />
                    <Route path="error" element={<InternalError />} />
                    <Route path="network-error" element={<NetworkError />} />
                    <Route path="contracts/variables/change" element={<RequireAuth roles={[ADMIN]}><ContractMaintenanceFormPage /> </RequireAuth> } />
                    <Route path="credits/engine/v2/variables/change" element={<RequireAuth roles={[ADMIN]}><CreditVariablesMaintenanceFormPage /> </RequireAuth> } />
                    <Route path="credits/engine/v2/providers/change" element={<RequireAuth roles={[ADMIN]}><ProvidersForm /> </RequireAuth> } />
                    <Route path="/logout" element={<Logout />} />
                </Route>
                <Route path="*" element={<NotFound />} />
                <Route path="login" element={<Login />} />
            </Routes>
        </HashRouter>

    );
};

export default AppRoutes;